import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useGettext } from '@jshmrtn/vue3-gettext';
import { Flash } from '@/core/Flash';
import CustomerForm from '@/modules/customer/components/CustomerForm.vue';
import { Customer } from '@/modules/customer/Customer';


export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerCreate',
  setup(__props) {

const { $gettext } = useGettext();
const router = useRouter();
const customer = ref<Partial<Customer>>({
	invoice: {
		address: '',
		zipcode: '',
		city: '',
		email: '',
	},
	languages: [],
	law_firms: [],
});

const saved = (customer) => {
	Flash.success($gettext('Kund tillagd'));
	router.push({
		name: 'customer.edit',
		params: { id: customer.id },
	});
};

const cancel = () => {
	router.push({ name: 'customer.index' });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CustomerForm, {
    "page-title": _unref($gettext)('Ny kund'),
    customer: customer.value,
    onSaved: saved,
    onCancel: cancel,
    "for-create": true
  }, null, 8, ["page-title", "customer"]))
}
}

})